import * as React from 'react';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar, {AppBarProps as MuiAppBarProps} from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import ThemeChange from "../../components/ThemeChange";
import LocalChange from "../../components/LocalChange";
import NavMenu from "../NavMenu";
import Router from "../../routes";
import {Grid} from "@mui/material";
import LoginWallet from "../LoginWallet";

const drawerWidth = 240;
const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: "100%",
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

export default function MainLayout() {
    const [open] = React.useState(true);

    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <AppBar position="fixed" open={open}>
                <Toolbar>

                    <Box sx={{width: '100%'}}>
                        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>

                            <Grid item xs={2}>
                                LOGO
                            </Grid>
                            <Grid item xs={5}>
                                <NavMenu/>
                            </Grid>
                            <Grid item xs={5} style={{alignItems: "end"}}>
                                <LoginWallet/>
                                <ThemeChange/>
                                <LocalChange/>
                            </Grid>
                        </Grid>
                    </Box>


                </Toolbar>
            </AppBar>

            <Box component="main" sx={{flexGrow: 1, p: 3}}>
                <DrawerHeader/>
                <Router></Router>
            </Box>
        </Box>
    );
}
